import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { useCallback, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { storeSongsPath } from '../../../utils/routeHelpers'
import { useRouter } from 'next/router'
import classNames from 'classnames'
import styles from './../../../components/_header.module.scss'

function StoreHeaderSearch() {
  const { register, getValues, setValue, handleSubmit } = useForm<FormData>({
    mode: 'onChange'
  })

  const [query, setQuery] = useState('')

  const router = useRouter()

  useEffect(() => {
    if (router.query.q) {
      setQuery(router.query.q as string)
    }
  }, [router.query])

  const handleSearch = useCallback(async (event) => {
    setQuery(event.target.value)
  }, [])

  const redirectToSongs = () => {
    router.push(storeSongsPath({ q: getValues('search') }), undefined, {
      shallow: true
    })
    setValue('search', '')
    setQuery('')
  }

  return (
    <form
      className={classNames(
        'control has-icons-left is-hidden-touch',
        styles.storeSearchForm
      )}
      onSubmit={handleSubmit(redirectToSongs)}
    >
      <input
        name="search"
        className="input"
        type="text"
        value={query}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleSearch(e)}
        ref={register}
        placeholder="Search"
      />
      <span className="icon is-small is-left">
        <FontAwesomeIcon icon={faSearch} />
      </span>
    </form>
  )
}

export default StoreHeaderSearch
